// Initialize all swipers with the same class
        document.addEventListener('DOMContentLoaded', function() {
            // Select all swiper containers with the class
            const swiperContainers = document.querySelectorAll('.swiper-collection-products');
            
            // Iterate through each container and create a Swiper instance
            swiperContainers.forEach((container, index) => {
                // Find the navigation elements specific to this swiper
                const nextEl = container.parentElement.querySelector('.swiper-collection-next');
                const prevEl = container.parentElement.querySelector('.swiper-collection-prev');
                
                // Create a unique class for navigation elements if needed
                // or use data attributes to associate with this instance
                
                new Swiper(container, {
                    slidesPerView: 1.2,
                    slidesPerGroup: 1,
                    spaceBetween: 20,
                    loop: false,
                    
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            slidesPerGroup: 1,
                            spaceBetween: 14,
                        },
                        1024: {
                            slidesPerView: 3,
                            slidesPerGroup: 1,
                            spaceBetween: 14,
                        },
                    },
                    
                    // Navigation arrows
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                });
            });
        });